export default {
  "nav.spreadsheet": "Spreadsheet",
  "nav.categories": "Categories",
  "nav.guides": "Guides",
  "nav.faq": "FAQ",
  "nav.home": "Home",
  "nav.visitMain": "Visit Main Website",
  "nav.shoppingGuide": "Shopping Guide",

  "hero.eyebrow": "The Basetao Spreadsheet Resource Center",
  "hero.title": "Basetao Spreadsheet: Products, Sellers & Buying Guides",
  "hero.subtitle": "Explore handpicked product categories, seller tips and practical buying guides — everything organized in one clean, easy-to-scan hub.",
  "hero.cta1": "Basetao Spreadsheet",
  "hero.cta2": "Buy It Now",
  "hero.note": "All product links open on the main website",

  "dropdown.label": "Browse categories",
  "dropdown.placeholder": "Select a product category",

  "categories.title": "Explore Product Categories",
  "categories.subtitle": "Jump straight to the products you care about. Each category opens a filtered list on the main website.",
  "categories.shoes": "Shoes",
  "categories.hoodies": "Hoodies / Sweaters",
  "categories.tshirts": "T-Shirts",
  "categories.jackets": "Jackets",
  "categories.pants": "Pants / Shorts",
  "categories.headwear": "Headwear",
  "categories.sets": "Sets",
  "categories.underwear": "Underwear / Underpants",
  "categories.jersey": "Jersey",
  "categories.accessories": "Accessories",
  "categories.bags": "Bags",
  "categories.belts": "Belts",
  "categories.perfumes": "Perfumes",
  "categories.other": "Other Stuff",
  "categories.viewAll": "Browse all on main website",

  "about.title": "What Is the Basetao Spreadsheet?",
  "about.p1": "The Basetao spreadsheet brings product links, seller notes and buying tips together in one easy-to-scan directory. Instead of searching one item at a time, you get a clear map of every category — from shoes and hoodies to bags and perfumes.",
  "about.p2": "Each category opens a filtered view on the main website, so you move from a broad idea to a specific product in a single click. The result is a faster, calmer way to find exactly what you are looking for.",
  "about.p3": "Alongside the directory, we publish practical buying guides that cover sellers, shipping and quality control — all written to help you shop with more confidence.",

  "guides.title": "Latest Basetao Guides",
  "guides.subtitle": "Practical, original guides to help you browse and buy with confidence.",
  "guides.cardTitle": "Basetao Spreadsheet: Complete Guide (2026)",
  "guides.cardDesc": "Learn how the spreadsheet works, browse the categories, find reliable sellers and understand shipping and quality control before you buy.",
  "guides.readArticle": "Read the full guide",
  "guides.updated": "Updated Aug 2026",
  "guides.badge": "Buying Guide",

  "faq.title": "Frequently Asked Questions",
  "faq.subtitle": "Quick answers about the Basetao spreadsheet and how to use it.",
  "faq.q1": "What is the Basetao spreadsheet?",
  "faq.a1": "It is a curated directory of product categories, links and buying notes that point to the main website.",
  "faq.q2": "How do I browse products?",
  "faq.a2": "Use the category dropdown or the category cards below. Each option opens a filtered product list on the main website.",
  "faq.q3": "Is it free to use?",
  "faq.a3": "Yes — browsing the directory and reading the guides is free. Purchases are handled on the main website.",
  "faq.q4": "How do I buy something?",
  "faq.a4": "Choose a category, find your product on the main website, then complete the checkout there.",

  "cta.title": "Ready to Explore the Basetao Spreadsheet?",
  "cta.subtitle": "Browse every category in one place, then jump straight to the products you want.",
  "cta.primary": "Explore Basetao Spreadsheet",
  "cta.secondary": "Visit Main Website",

  "footer.disclaimer": "This website is an independent informational resource. Product information, sellers, prices and availability may change. Always verify important details on the main website before purchasing.",
  "footer.rights": "© 2026 Basetao Spreadsheet. All rights reserved.",
  "footer.resources": "Resources",
  "footer.explore": "Explore",
  "footer.home": "Home",
  "footer.guide": "Basetao Spreadsheet Guide",
  "footer.categories": "Product Categories",
  "footer.visitMain": "Visit Main Website",

  "article.notFound": "Article Not Found",
  "article.notFoundDesc": "The article you are looking for does not exist or has been moved.",
};